import {
  _getUnitType,
  _getProvinceOrCity,
  _getUnitList,
  _unitCreateEditDelete,
  _getUnitDetailWithId,
  _getHallList,
  _getCeremonyList,
  _getAccountList,
  _hallCreateOrEdit,
  _deleteHall,
  _getUnitStatisticsWithId,
  _getTemplateAllList,
  _templateCreateOrEdit,
  _deleteTemplate
} from '@/api/Unit'
import {
  catchErr
} from '@/utils/utils'
import {
  Message
} from 'element-ui'

export default {
  // 获取单位类型
  async getUnitType_A({
    commit,
    state
  }) {
    let [err, res] = await catchErr(_getUnitType());
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      let resData = res.data;
      resData.forEach(item => {
        item.id = item.id.toString()
      })
      commit("SETOPTIONS", {
        arrUnitTypes: resData
      })
    }
    return true;
  },

  // 获取省市列表
  async getProvinceOrCity_A({
    commit,
    state
  }, params) {

    let [err, res] = await catchErr(_getProvinceOrCity({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      return res.data
    }
    return [];
  },

  // 获取单位列表
  async getTableList_A({
    commit,
    state
  }) {
    let searchData = state.searchData;
    let params = {
      type: state.activeTabId
    };
    if (searchData.province) {
      params.province = searchData.province;
    }
    if (searchData.city) {
      params.city = searchData.city;
    }
    if (searchData.appShortName) {
      params.appShortName = searchData.appShortName;
    }
    if (searchData.appCode) {
      params.appCode = searchData.appCode;
    }

    let pageData = state.pageData;

    let [err, res] = await catchErr(_getUnitList({
      data: params,
      pageInfo: pageData
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      let resData = res.data;
      let resPage = res.pageInfo;
      commit("SETOPTIONS", {
        pageData: resPage,
        tableData: resData
      })
    }
    return;
  },
  // 新建编辑删除
  async doCreateEditDelete_A({
    commit,
    state
  }, params) {

    let [err, res] = await catchErr(_unitCreateEditDelete({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1044) {
        Message.error("单位简称重复");
      } else if (res.status == 1073) {
        Message.error("单位全称重复");
      } else if (res.status == 1074) {
        Message.error("无法删除该单位,有职员使用该单位");
      } else if (res.status == 1075) {
        Message.error("无法删除该单位,该单位已有告别会");
      } else if (res.status == 1091) {
        Message.error("无法删除该单位,该单位已创建纪念堂");
      }else if (res.status == 1000) {
        return true;
      } else {
        Message.error(res.message || '系统异常');
      }
    }
    return;
  },

  // 获取单位详情
  async getUnitDetailWithId_A({
    commit,
    state
  }, ) {

    let [err, res] = await catchErr(_getUnitDetailWithId({
      data: state.detailAppId
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {

        commit("SETOPTIONS", {
          appDetail: res.data
        })

      } else {
        Message.error(res.message || '系统异常');
      }
    }
    return;
  },

// 获取单位统计
async getUnitStatisticsWithId_A({
  commit,
  state
}, ) {

  let [err, res] = await catchErr(_getUnitStatisticsWithId({
    data: state.detailAppId
  }));
  if (err) {
    Message.error(err.message || '系统异常');
  } else if (res) {
    if (res.status == 1000) {

      commit("SETOPTIONS", {
        appStatistics: res.data
      })
    } else {
      Message.error(res.message || '系统异常');
    }
  }
  return;
},
// 告别会列表
async getCeremonyList_A({
  commit,
  state
}) {
  let [err, res] = await catchErr(_getCeremonyList({
    data: {
      unitId:state.detailAppId,
    },
    pageInfo: state.detailPageData
  }));
  if (err) {
    Message.error(err.message || '系统异常');
  } else if (res) {
    if (res.status == 1000) {

      res.data.forEach((_t) => {
        if(_t.takerName != undefined && _t.takerName != ''){
        }else{
          _t.takerName = '—'
        }
        if(_t.takerTel != undefined && _t.takerTel != ''){
        }else{
          _t.takerTel = '—'
        }
      });

      commit("SETOPTIONS", {
        ceremoryTableData: res.data,
        detailPageData:res.pageInfo
      })

    } else {
      Message.error(res.message || '系统异常');
    }
  }
  return;
},

  //  告别厅列表
  async getHallList_A({
    commit,
    state
  }) {

    let [err, res] = await catchErr(_getHallList({
      data: state.detailAppId,
      pageInfo: state.detailPageData
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {
        commit("SETOPTIONS", {
          hallTableData: res.data,
          detailPageData:res.pageInfo
        })

      } else {
        Message.error(res.message || '系统异常');
      }
    }
    return;
  },
  // 运营帐号列表
  async getAccountList_A({
    commit,
    state
  }) {

    let [err, res] = await catchErr(_getAccountList({
      data: {
        unitId:state.detailAppId,
      },
      pageInfo: state.detailPageData
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {
        console.log(res.data)
        res.data.forEach((_t) => {
          if(_t.nick != undefined && _t.nick != ''){
          }else{
            _t.nick = '—'
          }
          if(_t.tel != undefined && _t.tel != ''){
          }else{
            _t.tel = '—'
          }
          if(_t.enterpriseMobile != undefined && _t.enterpriseMobile != ''){
          }else{
            _t.enterpriseMobile = '—'
          }
        });

        commit("SETOPTIONS", {
          accountTableData: res.data,
          detailPageData:res.pageInfo
        })

      } else {
        Message.error(res.message || '系统异常');
      }
    }
    return;
  },
   // 新建编辑告别厅
   async createOrEditHall_A({
    commit,
    state
  }, params) {

    let [err, res] = await catchErr(_hallCreateOrEdit({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1011) {
        Message.error("告别厅名称重复");
      } else if (res.status == 1000) {
        return true;
      } else {
        Message.error(res.message || '系统异常');
      }
    }
    return;
  },
  // 删除告别厅
  async deleteHall_A({
    commit,
    state
  }, params) {

    let [err, res] = await catchErr(_deleteHall({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1020) {
        Message.error("不能删除举行过告别会的告别厅");
      } else if (res.status == 1000) {
        return true;
      } else {
        Message.error(res.message || '系统异常');
      }
    }
    return;
  },
  //  模板列表
  async getTemplateAllList_A({
    commit,
    state
  }) {

    let [err, res] = await catchErr(_getTemplateAllList({
      data: state.detailAppId
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {
        var resData = res.data;
        const divThis = document.createElement('div');
        resData.forEach(item => {
          divThis.innerHTML = item.lifeStory;
          var text = divThis.innerText;
          item.lifeStoryText = text;
        })
        console.log(resData)
        commit("SETOPTIONS", {
          templateTableData: resData
        })
      } else {
        Message.error(res.message || '系统异常');
      }
    }
    return;
  },
  // 新建编辑模板
  async templateCreateOrEdit_A({
    commit,
    state
  }, params) {

    let [err, res] = await catchErr(_templateCreateOrEdit({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1011) {
        Message.error("告别厅名称重复");
      } else if (res.status == 1000) {
        return true;
      } else {
        Message.error(res.message || '系统异常');
      }
    }
    return;
  },
  // 删除模板
  async deleteTemplate_A({
    commit,
    state
  }, params) {

    let [err, res] = await catchErr(_deleteTemplate({
      data: params
    }));
    if (err) {
      Message.error(err.message || '系统异常');
    } else if (res) {
      if (res.status == 1000) {
        return true;
      } else {
        Message.error(res.message || '系统异常');
      }
    }
    return;
  },

}


// _getTemplateAllList,
// _templateCreateOrEdit,
// _deleteTemplate


// WEBPACK FOOTER //
// ./src/store/modules/Unit/actions.js